import { CompanyListPage } from '@pages/company';
import { createMeta } from '@shared/utils';

export function meta() {
  return createMeta('Компании', 'Управление компаниями');
}

export default CompanyListPage;
